import { FiltersDetail } from '../../app/modules/chart/interface/interfaces';
import { ReduxAction, ReduxType } from '../interface';

export const FILTER_DEFAULT_USER_STATUS = 'New,Active,Pending';
const data: FiltersDetail = {
  crd: '',
  divisionId: '',
  email: '',
  firstName: '',
  junctionId: '',
  lastName: '',
  status: FILTER_DEFAULT_USER_STATUS,
  positionId: '',
  teamId: '',
  applianceIdList: []
};
export default (state: FiltersDetail, action: ReduxAction<FiltersDetail>) => {
  if (!state) {
    state = data;
  }
  if (action.type === ReduxType.FILTER_TABLE) {
    return Object.assign({}, state, action.payload);
  } else {
    return state;
  }
};
